<div class="main">
    <app-header-section></app-header-section>
    <app-breadcrumb-blog-single></app-breadcrumb-blog-single>
    <app-blog-single-section></app-blog-single-section>
    <app-footer-section></app-footer-section>
    <app-modal-search></app-modal-search>
    <app-modal-menu></app-modal-menu>
    <app-scrollup></app-scrollup>
</div>
